import { selectList } from "state/selectors/data";

const supportedTypes = [
    "hotelsystems",
    "hotres",
    "profitroom",
    "nfhotel",
    "idosell",
    "betasi",
];

export function selectBeIntegration(store, list) {
    const integrations = selectList(store, "cms.integrations", list);
    return integrations
        .filter((integration) => {
            return supportedTypes.includes(integration.type);
        })
        .sort((a, b) => {
            // active first
            if (a.active && !b.active) return -1;
            if (!a.active && b.active) return 1;
            return 0;
        })[0];
}
